export default __webpack_public_path__ + "static/media/58.12993bd3.png";